import $ from 'jquery';

/**
 * @description スクロールボタンの追従
 * @export
 * @returns
 */
export default function adjustScrollTopButton(){
  const elem = document.querySelector('.js-scroll-top');

  if(elem === null) return;

  const className = {
    hide: 'scroll-top--hide',
    scrolling: 'scroll-top--scrolling',
    scrollend: 'scroll-top--scrollend'
  };

  const DOCUMENT_HEIGHT = document.body.clientHeight;
  const SCROLL_TOP = $(window).scrollTop();
  const VIEW_HEIGHT = (window.innerHeight)? window.innerHeight : document.documentElement.clientHeight;
  const HIDING_HEIGHT = 500;
  const FOOTER_HEIGHT = document.querySelector('.footer').getBoundingClientRect().height;
  const BREAK_POINT = {
    hide:HIDING_HEIGHT,
    scrolling:DOCUMENT_HEIGHT - (VIEW_HEIGHT + FOOTER_HEIGHT + 300),
    scrollend:DOCUMENT_HEIGHT
  };

  for(let key in BREAK_POINT){
    elem.classList.remove(className[key]);
  }

  for(let key in BREAK_POINT){
    if(SCROLL_TOP < BREAK_POINT[key]){
      elem.classList.add(className[key]);
      return;
    }
  }
}